import getBreakpoint from "selectors/breakpoint/getBreakpoint";
import { BreakpointDefinition } from "utils/Breakpoint";
import { createSelector } from "reselect";

export const getUseMobileControls = createSelector(
  [getBreakpoint],
  (breakpoint) => breakpoint.isLessThanOrEquals(BreakpointDefinition.XS),
);

export default getUseMobileControls;
